import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=31cc8311&"
import script from "./menus.vue?vue&type=script&lang=js&"
export * from "./menus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31cc8311')) {
      api.createRecord('31cc8311', component.options)
    } else {
      api.reload('31cc8311', component.options)
    }
    module.hot.accept("./menus.vue?vue&type=template&id=31cc8311&", function () {
      api.rerender('31cc8311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/authority/components/menus.vue"
export default component.exports